'use client';

import { NavigateNext } from '@mui/icons-material';
import { Breadcrumbs, Typography, styled, useTheme } from '@mui/material';
import { useBreadcrumb } from '@next-box/breadcrumb';
import { kebabCase } from 'lodash-es';
import { usePathname } from 'next/navigation.js';
import { Section } from '#components/Section/index.tsx';
import { Route } from '#enums/routes.ts';
import { TextLink } from '../TextLink/index.tsx';

const ScrollContainer = styled('div')(() => ({
  '::-webkit-scrollbar': {
    display: 'none' /* Chrome, Safari and Opera */,
  },
  msOverflowStyle: 'none' /* IE and Edge */,
  overflowX: 'scroll',
  overflowY: 'hidden',
  scrollbarWidth: 'none' /* Firefox */,
}));

export const Breadcrumb = () => {
  const { breadcrumb, onBreadcrumbLinkClick } = useBreadcrumb();
  const pathname = usePathname();
  const theme = useTheme();

  return pathname === Route.Root.toString() ? undefined : (
    <Section sx={{ paddingBottom: theme.spacing(1.5), paddingTop: theme.spacing(1.5) }}>
      <ScrollContainer>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNext fontSize="small" />}
          sx={{
            height: '24px',
            width: 'max-content',
          }}
        >
          {breadcrumb.map((item, index) =>
            index < breadcrumb.length - 1 ? (
              <TextLink
                key={kebabCase(item.label)}
                onClick={e => {
                  onBreadcrumbLinkClick?.(item, e);
                }}
                to={item.href}
              >
                {item.label}
              </TextLink>
            ) : (
              <Typography key={kebabCase(item.label)}>{item.label}</Typography>
            ),
          )}
        </Breadcrumbs>
      </ScrollContainer>
    </Section>
  );
};
